// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SettingsSlider_wrapper__2q69Q","prevArrow":"SettingsSlider_prevArrow__236-C","nextArrow":"SettingsSlider_nextArrow__8cnnW","hidden":"SettingsSlider_hidden__18V-n"};